export default __webpack_public_path__ + "static/im_bg_cta_1024-738d06fd690e9a73db6deed71454ebe0.png";